import { Line } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip } from 'chart.js';

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip);

interface Props {
  labels?: string[];
  data: number[];
  color?: string;
  height?: number;
}

export function Sparkline({ labels, data, color = '#7c5cff', height = 36 }: Props) {
  const chartData = {
    labels: labels ?? data.map((_, i) => String(i)),
    datasets: [{
      data,
      borderColor: color,
      backgroundColor: color + '30',
      fill: true,
      tension: 0.35,
      pointRadius: 0,
      pointHoverRadius: 4,
      borderWidth: 1.5,
    }],
  };
  const options = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true, intersect: false, mode: 'index' as const },
    },
    scales: {
      x: { display: false },
      y: { display: false, beginAtZero: true },
    },
    maintainAspectRatio: false,
    responsive: true,
  };
  return (
    <div style={{ height, width: '100%' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}
